// extracted by mini-css-extract-plugin
export default {"note":"style_note__zVmFc","expired":"style_expired__sFmO2"};